module.exports = __webpack_public_path__ + "img/PIGGY.4136c9fe.svg";